import * as types from "./documento.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_ANEXO:
      return state.merge({ anexo: action.payload });
    case types.SET_ANEXO_CUSTOMIZADO:
      return state.merge({ anexoCustomizado: action.payload });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};
store.registerDynamicModule("documento", reduce);
